export const PICKUP_API_LOOKAHEAD_DAYS = 50;
export const PICKUP_WORKING_DAYS_LIMIT = 30;
